/* eslint @typescript-eslint/no-var-requires: "off" */
const { Autoplay, Navigation } = require('swiper/modules');

export const swiperConfig = {
  modules: [Autoplay, Navigation],
  navigation: true,
  spaceBetween: 50,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: {
    delay: 12000,
    disableOnInteraction: true,
  },
  speed: 2000,
};

export const BANNER_TOP_CLOSED = 'bannerTopClosed';
export const DEFAULT_DESKTOP_OFFSET = -200;
export const HEADER_HEIGHT_DESKTOP = 36;
